
import ProblemKendaraanMain from "../../../features/problem/problem-kendaraan/component/ProblemKendaraanMain";

const ProblemKendaraanPage = () => {
  return <ProblemKendaraanMain />;
};

export default ProblemKendaraanPage;
